/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, message, Drawer, Form, Select } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import AvatarUplaod from '../../../components/Custom/AvatarUpload'
import SystemUserAvatar from '../../../components/Custom/SystemUserAvatar'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedUser, form } = this.props
		const { setFieldsValue } = form
		if (selectedUser) {
			setFieldsValue({
				full_name: selectedUser.full_name,
				username: selectedUser.username,
				email: selectedUser.email,
				gender: selectedUser.gender,
				user_type: selectedUser.user_type
			})
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveSystemUser, onClose, isEdit, selectedUser } = this.props
		const { barangay_uid } = AuthStore
		// const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			const fileList = _.has(values.avatar, 'fileList') ? values.avatar.fileList : []
			const formattedFiles = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
			const files = []
			if (formattedFiles.length > 0) {
				files.push(formattedFiles[formattedFiles.length - 1])
			}
			delete values.avatar

			let params = Object.assign({}, values, { files, barangay_uid })
			if (isEdit && selectedUser) {
				params = Object.assign({}, params, { user_uid: selectedUser.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_user', content: 'Saving System user, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveSystemUser(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_user', content: 'System user successfully saved.' })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving system user')
					message.error({ key: 'set_user', content: err.message.replace('GraphQL error:', '') })
					// resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedUser } = this.props
		const { getFieldDecorator } = form
        
		return (
			<Drawer
				title="Manage System User"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row type='flex' justify='center'>
						<Form.Item label=''>
							{ getFieldDecorator('avatar', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<AvatarUplaod 
									system_user_uid={selectedUser ? selectedUser.uid : null} 
								/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Full Name'>
							{ getFieldDecorator('full_name', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Full name'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Username'>
							{ getFieldDecorator('username', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Username'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Email'>
							{ getFieldDecorator('email', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Email address'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Gender'>
							{ getFieldDecorator('gender', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Gender'>
									<Select.Option value='Male'>Male</Select.Option>
									<Select.Option value='Female'>Female</Select.Option>
								</Select>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='User Type'>
							{ getFieldDecorator('user_type', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select User Type'>
									<Select.Option value='System Admin'>System Admin</Select.Option>
									<Select.Option value='Clerk'>Clerk</Select.Option>
									<Select.Option value='Medical Personnel'>Medical Personnel</Select.Option>
								</Select>
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_SYSTEM_USER = gql`
    mutation setSystemUser($input: JSON) {
		setSystemUser(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-system-user' }),
	inject('AuthStore'),
	graphql(SET_SYSTEM_USER, {
		props({ mutate }) {
			return {
				saveSystemUser(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['systemUsers','SystemUserAvatar']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
